<template>
  <v-container class="ab-container">
    <v-row justify="center" class="h-100 flex-column" align="center">
      <v-col cols="12" class="pb-0">
        <div class="d-flex justify-left">
          <v-icon color="#4caf50" class="mr-3">mdi-domain</v-icon>
          <div class="text-contactReqTSA">บริษัท วัน ออเทน จำกัด</div>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex justify-left">
          <v-icon color="#4caf50" class="mr-3">mdi-map-marker</v-icon>
          <div class="text-contactReqTSA">ที่อยู่</div>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0">
        <div class="d-flex justify-left">
          <div class="text-contactReqTSA pl-9 text-left">
            1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16<br>
            ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex justify-left">
          <v-icon color="#4caf50" class="mr-3">mdi-email</v-icon>
          <div class="text-contactReqTSA">team@oneauthen.in.th</div>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex justify-left">
          <v-icon color="#4caf50" class="mr-3">mdi-phone</v-icon>
          <div class="text-contactReqTSA">ศูนย์บริการข้อมูลลูกค้า: 02-257-7111</div>
        </div>
      </v-col>
      <!-- <v-col cols="12">
        <div class="d-flex card-map">
          <a href="https://goo.gl/maps/UEa339PqzBxFDTu58" rel="noreferrer" target="_blank" class="gmap">
            <img src="../../assets/map.png" alt="Nature" class="responsive">
          </a>
        </div>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
    }
  },
  created () {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 959
    })
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
.h-100 {
  height: 100% !important;
}
.ab-container {
  max-width: 100% !important;
}
.text-contactReqTSA {
  font-size: 14px;
  font-weight: 500;
  color: rgb(126, 126, 126);
}
.file-input {
  display: flex !important;
  /* padding-right: 20% !important; */
}
.card-map {
  /* padding: 4px; */
  /* border-radius: 7px; */
  /* border: 2px solid #63A038; */
  display: flex;
  justify-content: center;
  align-self: center;
  background-color: white;
  /* width: 360px; */
  height: 236px;
}
img.responsive {
  width: 100%;
  height: 100%;
}
</style>
